export default {
  "translation": {
    "card_application": "卡片申请",
    "card_application_des": "申请您的Sonic卡，可在全球4400多万支持Visa的商户使用。",
    "spend_your_crypto_like_fiat": "像法币一样使用你的加密货币",
    "use_globally_across_borders": "全球使用，跨越边界",
    "ultra_low_trans_costs": "超低交易成本",
    "seamless_and_secure": "无缝且安全",
    "two_factor_verification": "双因素验证",
    "two_factor_verification_des": "使用电子邮件件、电话、生物识别和/或身份验证器应用程序安全登录",
    "safety_pin": "安全 PIN",
    "safety_pin_des": "通过设置 PIN 限制访问私人信息",
    "trans_3ds_verification": "3DS 验证",
    "trans_3ds_verification_des": "在处理之前授权购买",
    "additional_security": "额外的安全性",
    "additional_security_des": "在应用程序上轻松设置卡限额和其他安全功能",
    "get_your_redotpay_card_in_steps": "通过三个简单步骤获取你的 Sonic 卡。",
    "get_your_redotpay_card_subtitle": "像法币一样使用加密货币：被全球 44M+ 支持 Visa 的商户接受。",
    "continue_key": "继续",
    "bind_your_mobile_number": "绑定你的手机号码",
    "complete_identity_verification": "完成身份验证",
    "apply_a_virtual_or_physical_card": "申请虚拟或实体卡",
    "transactions": "交易",
    "need_mobile_bind_confirm": "需要先绑定手机",
    "info": "信息",
    "card_trans_status_refund_pending": "退款待处理",
    "card_trans_status_refund_success": "退款成功",
    "card_trans_status_refund_fail": "退款失败",
    "card_trans_status_refund_wait": "退款等待",
    "card_trans_status_pending": "已授权",
    "card_trans_status_cleared": "已清算",
    "card_trans_status_declined": "被拒绝",
    "card_trans_status_canceled": "已撤销",
    "card_trans_status_refund": "退款",
    "card_trans_status_refund_cancel": "取消退款",
    "refund": "退款",
    "transaction_list": "交易列表",
    "more": "更多",
    "top_questions": "热门问题",
    "faq": "常见问题",
    "self_service": "自助服务",
    "support_center": "帮助中心",
    "hello": "你好",
    "updated_on": "更新于",
    "chat_with_us": "与我们聊天",
    "warning": "警告",
    "security_option_change_alert_prompt": "解绑/修改 Google 身份验证器/手机/电子邮件/PIN 后，提币和内部转账将被禁用，卡交易将在接下来的 24 小时内每笔交易限额为 1000 美元，以确保安全。",
    "cancel": "取消",
    "ok": "确定",
    "account_deletion_regret_promp": "账户删除允许你有 15 天的后悔期。当你在申请删除后的 15 天内再次登录时，你的申请将被取消，你的账户可以继续正常使用。",
    "view_on_blockchain_explorer": "在区块链浏览器上查看",
    "biz_sn": "交易编号",
    "type": "类型",
    "create_time": "创建时间",
    "logout_confirm": "你确定要退出登录吗？",
    "wallet": "钱包",
    "continue_with_google": "继续使用 Google",
    "insufficient_balance_deposit_guide": "余额不足。存入资产，否则你的交易将被拒绝，并可能收取费用。",
    "to": "到",
    "bill_will_be_sent_to": "账单将发送到",
    "bill_statement": "账单凭据",
    "export_bill": "导出账单声明",
    "this_month": "本月",
    "last_month": "上个月",
    "last_3_month": "最近 3 个月",
    "this_year": "今年",
    "last_year": "去年",
    "customize": "自定义",
    "bill_export_success": "账单声明已发送到你的电子邮件，请检查",
    "bill_empty": "你的账单为空",
    "channel": "渠道",
    "merchant_country": "商户国家",
    "status": "状态",
    "withdraw_detail": "提币详情",
    "new_key": "新增",
    "deposit": "充值",
    "withdraw": "提币",
    "single_limit": "单笔限额",
    "all": "全部",
    "minimum": "最低",
    "available": "可用",
    "received_amount": "收到金额",
    "withdrawl": "提币",
    "network_fee": "网络费用",
    "register": "注册",
    "register_login": "注册/登录",
    "login": "登录",
    "email_Phone": "电子邮件/电话号码",
    "email": "电子邮件",
    "mobile": "手机",
    "next": "下一步",
    "or_continue_with": "或继续使用",
    "forgot_pw": "忘记密码？",
    "welcome_to_redotpay": "欢迎来到 Sonic Pay",
    "verify_code": "验证码",
    "get_code": "获取验证码",
    "by_creating_an_account": "通过创建账户，你同意我们的",
    "privacy_policy": "隐私政策",
    "terms_conditions": "条款和条件",
    "and": "和",
    "modify_pin": "更改 PIN",
    "pin_subtitle": "安全 PIN 提供快速验证，使你可以轻松查看卡号和 CVV 信息。",
    "password_set_first_login": "首次登录设置密码",
    "next_step": "下一步",
    "confirm": "确认",
    "username": "用户名",
    "password": "密码",
    "send_code": "发送验证码",
    "send_code_to": "验证码将发送到",
    "switch_option": "更改验证选项",
    "mobile_verification": "手机验证",
    "email_verification": "电子邮件验证",
    "choose_verify_method": "更改验证选项",
    "verify_pin": "安全 PIN",
    "google_authenticator_verification": "Google 身份验证器",
    "security": "安全",
    "bound": "已绑定",
    "unbound": "未绑定",
    "set": "管理",
    "unset": "未设置",
    "update_pw": "更改密码",
    "delete_account": "注销账号",
    "google_authenticator": "Google 身份验证器",
    "google_authenticator_subtitle": "Google 身份验证器保护你的提币和账户。",
    "download_install": "下载",
    "download_install_prompt": "首先你需要下载并安装身份验证器应用程序（Google 身份验证器）",
    "backup_key": "备份密钥",
    "save_backup_key": "将此备份密钥保存在安全位置",
    "google_authenticator_code": "Google 身份验证器code码",
    "email_subtitle": "电子邮件验证保护你的提币和账户。",
    "change_email": "更改电子邮件",
    "email_update": "电子邮件更新",
    "code": "验证码",
    "mobile_subtitle": "手机验证保护你的提币和账户。",
    "change_mobile": "更改手机",
    "mobile_update": "手机更新",
    "mobile_bind": "绑定手机",
    "email_bind": "绑定电子邮件",
    "old_password": "旧密码",
    "new_password": "新密码",
    "new_password_confirm": "确认新密码",
    "language": "语言",
    "appearance": "外观",
    "logout": "退出登录",
    "log_out_toast": "你已退出登录",
    "set_pin": "安全 PIN",
    "account_deletion_prompt_1": "此账户将无法恢复",
    "account_deletion_prompt_2": "所有由此账户创建的子用户/其他账户将被删除且无法恢复。",
    "account_deletion_prompt_3": "与此账户关联的所有 API 密钥将被删除。",
    "account_deletion_prompt_4": "此账户的所有当前委托和待处理的货币提币将被取消。",
    "account_deletion_prompt_5": "此账户的所有交易功能将被禁用。",
    "account_deletion_prompt_6": "未从此账户提取的资产将被视为自愿放弃的资产。",
    "account_deletion_prompt_7": "在你删除账户申请后，你可以有 15 天的撤回期。当你在删除请求后的 15 天内再次登录时，你的删除请求将被取消，账户可以继续使用。",
    "kyc_status_0": "未提交",
    "kyc_status_1": "验证中...",
    "kyc_status_2": "审核通过",
    "kyc_status_3": "审核失败",
    "kyc_status_4": "重新提交",
    "kyc_status_5": "提交给上游",
    "personal_info_review": "个人信息审核",
    "additional_info_request": "需要提供额外信息",
    "verifying": "验证中...",
    "form_submitted_will_review_asap_new": "你的申请已提交进行人工审核。该过程通常需要 3-5 天，但有时可能需要更长时间。请耐心等待。",
    "get_verified": "身份验证",
    "kyc_verified": "用户身份已验证",
    "approved": "审核通过",
    "not_able_to_submit_identity": "作为我们综合审查流程的一部分，我们需要您提供额外信息，以完成了解客户（KYC）和反洗钱（AML）的筛选程序。",
    "aml_review_failed": "为了继续您的申请，请点击下面的按钮完成自我声明表单填写。",
    "aml_declaration_prompt": "请注意，未能在接下来的14天内提供所请求的表单会导致您的申请被拒绝。",
    "verify_your_identity": "验证你的身份",
    "get_identity_verified": "验证你的身份才能购买和使用卡",
    "country_region": "国家/地区",
    "given_name": "名字",
    "surname": "姓氏",
    "date_of_birth": "出生日期",
    "document_type": "证件类型",
    "document_number": "证件号码",
    "given_name_intl": "名字（国际）",
    "surname_intl": "姓氏（国际）",
    "click_to_add_signature": "点击添加签名",
    "rewrite": "重写",
    "submit": "提交",
    "save": "保存",
    "accounts_are_not_available": "账户不可用",
    "abandon_assets": "放弃 {{amount}} {{currency}} 资产",
    "account_deletion_successful": "账户删除成功",
    "passwords_do_not_match": "密码不匹配",
    "password_reset_success": "密码重置成功",
    "password_confirm": "确认密码",
    "is_refund": "退款",
    "total_debt": "总债务",
    "your_account_is_in_arrears": "你的账户欠费。请存入足够的资金以结清余额。当你的余额在还清债务后≥10美元时，你的账户/卡将恢复。",
    "repayment": "还款",
    "debit_record": "借记记录",
    "no_data": "无数据",
    "payment": "支付",
    "transaction_details": "交易详情",
    "transaction_date": "交易日期",
    "transaction_id": "交易 ID",
    "view_linked_order": "查看关联订单",
    "rights_interests": "权益",
    "transaction_limit": "交易限额",
    "deposit_withdraw": "充值和提币",
    "card_purchased_number": "可购买的卡数量",
    "on_review_your_applicant": "我们正在审核你的申请",
    "form_en_only": "表格只能用英文填写",
    "available_to_spend": "可花费",
    "get_a_card": "获取 Sonic 卡，并在全球 44M+ 支持 Visa 的商户使用。",
    "virtual_card": "虚拟卡",
    "physical_card": "实体卡",
    "apply_card": "申请卡",
    "enjoy_seamless_spending": "享受无缝消费",
    "spend_and_withdraw": "享受无缝消费和 ATM 提币",
    "card_labeling": "卡标签",
    "card_tag": "卡标签",
    "edit_billing_address": "账单地址",
    "government_issued_id": "政府签发的身份证",
    "facial_recognition": "面部识别",
    "address": "地址",
    "personnel_information_details": "个人信息详情",
    "nation_list": "国家列表",
    "choose_channel": "验证模式",
    "mobile_channel_sms": "短信",
    "mobile_channel_smsAliyunWhatsApp": "WhatsApp",
    "card_application_order": "申请卡片订单",
    "promo_code_optional": "优惠码（可选）",
    "promo_code": "优惠码",
    "billing_address": "账单地址",
    "shipping_address": "邮寄地址",
    "shipping_to": "邮寄到",
    "card_purchase_fee": "卡购买费用",
    "card_holder_name": "持卡人姓名",
    "city": "城市",
    "province_state": "省/州",
    "postal_code": "邮编/邮政编码",
    "address_line1": "地址",
    "address_line2": "地址行 2",
    "please_fill_in_the_information_in_english": "表格只能用英文填写",
    "first_name": "名字",
    "last_name": "姓氏",
    "country_code": "国家代码",
    "card_application_list": "卡片申请列表",
    "buy_virtual_card": "购买虚拟卡",
    "buy_physical_card": "购买实体卡",
    "withdraw_list": "提币列表",
    "no_more_data": "没有更多数据",
    "select_a_network": "选择一个网络",
    "please_select_network": "请选择一个网络",
    "select_a_network_ensure": "请使用您选择区块链网络进行充值，通过其他网络充值可能会造成资产丢失",
    "network": "网络",
    "card_management": "卡片管理",
    "freeze": "冻结",
    "unfreeze": "解冻",
    "freeze_card_des": "一键冻结卡片后，您将无法使用该卡片进行消费，不会影响其他卡片，当您想解冻卡片，可以换返回此处重新启用",
    "freezing_trades": "冻结卡片会导致订单失败，进而导致交易失败或被拒绝交易收取额外费用",
    "unfreeze_your_card_desc": "一键解冻卡片后，您可以继续使用该卡片进行消费，不会影响其他卡片。当您想重新冻结卡片，可以返回此处重新冻结卡片",
    "card_tag_set_success": "卡标签设置成功",
    "bill": "账单",
    "setting": "设置",
    "limit": "限额",
    "assets_list": "资产列表",
    "empty_data": "无数据",
    "deposit_list": "充值列表",
    "date": "日期",
    "merchant_city": "商户城市",
    "card_number": "卡号",
    "card_type": "卡类型",
    "mcc": "MCC",
    "declined_reason": "拒绝原因",
    "card_authorization_payment": "卡片授权支付",
    "declined_transaction_fee": "拒绝交易费用",
    "verified": "已验证",
    "notifications": "通知",
    "need_to_add_bill_address": "需要添加账单地址",
    "need_to_add_shipping_address": "需要添加配送地址",
    "success": "成功",
    "welcome_redotpay": "欢迎来到 Sonic Pay！",
    "reset_pw_alert": "出于安全考虑，修改密码后，未来24小时内提现和内部转账将被禁用，卡交易将被限制为每笔交易$1000。",
    "no_more_records": "没有更多记录",
    "add": "添加",
    "address_label": "地址标签",
    "add_address": "添加地址",
    "this_field_is_required": "此字段为必填项",
    "ID_CARD": "身份证",
    "PASSPORT": "护照",
    "DRIVERS": "驾驶执照",
    "RESIDENCE_PERMIT": "居住证",
    "amount": "金额",
    "withdraw_status_waiting": "等待中",
    "withdraw_status_pending": "待处理",
    "withdraw_status_success": "成功",
    "withdraw_status_fail": "失败",
    "withdraw_status_canceled": "已取消",
    "withdraw_status_declined": "被拒绝",
    "withdraw_status_complete": "已完成",
    "order_id": "订单编号",
    "click_or_scroll_to_load_more": "点击或滚动加载更多",
    "minimum_deposit_amount": "最低充值金额",
    "deposit_arrival_confirmations": "充值到达：{{confirmations}} 次确认",
    "confirmations": "{{confirmations}} 次确认",
    "deposit_network": "充值网络",
    "minimum_deposit": "最低充值",
    "deposit_arrival": "充值到达",
    "current_address_supports_depositing": "当前地址仅支持充值 {{displayName}} 上的{{varietyCode}}，充值其他资产将会丢失。",
    "copy_successful": "复制成功",
    "update_password_successful": "密码更新成功",
    "update_successful": "更新成功",
    "successful": "成功",
    "signature_required": "需要签名",
    "deposit_successful": "充值成功",
    "sign_out": "登出",
    "cancel_withdraw_order_success": "取消提币订单成功",
    "delete_successful": "删除成功",
    "unfreeze_card_successful": "解冻卡成功",
    "card_nickname_set_success": "卡昵称设置成功",
    "trans_limit_adjusted_success": "交易限额调整成功",
    "set_card_pin_success": "设置卡 PIN 成功",
    "withdraw_apply_commit_please_wait": "提币申请已提交，请稍候",
    "unfreeze_success": "解冻成功",
    "freeze_success": "冻结成功",
    "withdraw_duration_tip": "提币申请将在一个工作日内处理",
    "you_will_withdraw": "你将提币",
    "withdraw_info": "提币信息",
    "please_confirm_same_network": "确保你选择的充值网络与充值网络匹配，否则资产可能会丢失。",
    "cancel_withdraw_order_confirm": "你确定要取消提币订单吗？",
    "valid_thru": "有效期至",
    "last_7_days": "最近 7 天",
    "last_30_days": "最近 30 天",
    "today": "今天",
    "all_done": "全部完成",
    "view_details": "查看详情",
    "withdraw_success": "提币成功",
    "pay": "支付",
    "fee": "手续费",
    "discount": "优惠",
    "price": "价格",
    "card_application_details": "卡片申请详情",
    "card_pin": "卡片PIN码",
    "card_pin_format_helper": "不能包含三个连续相同的数字或连续的数字",
    "digit_variable": "{{count}} 位",
    "address_book": "地址簿",
    "unlimited": "无限额",
    "single": "单笔",
    "update_card_pin": "更新卡PIN码",
    "set_card_pin": "设置卡PIN码",
    "report_lost": "卡片挂失",
    "report_lost_card": "卡片挂失",
    "card_lost_report_alert": "卡挂失后您将不能解除挂失状态，卡片变为不可用状态，如想再次使用卡片或申请换卡请联系客服。",
    "pending": "待处理",
    "frozen": "已冻结",
    "phone_number": "手机号码",
    "search": "检索",
    "reset": "重置",
    "total_amount": "总金额",
    "actual_amount": "实际金额",
    "already_have_an_account": "已有账户？",
    "create_account": "注册Sonic Pay新用户",
    "total_balance": "总余额",
    "cards_balance_available_promp": "根据钱包资产实时计算的信用额度",
    "got_it": "知道了",
    "review_details": "确认信息",
    "delete_this_address": "确定删除此地址?",
    "currency": "货币",
    "merchant_name": "商家名称",
    "request_time": "请求时间",
    "is_transaction_allowed": "此交易是否允许？",
    "approve": "批准",
    "decline": "拒绝",
    "card_in_production": "卡片生产中",
    "redotpay_card_sent": "Redotpay卡已邮寄",
    "redotpay_card_activated": "Redotpay卡已激活",
    "activate_card": "激活卡片",
    "paste": "粘贴",
    "fees_included": "费用包含",
    "fx_fee": "外汇手续费",
    "small_auth_fee": "小额交易费",
    "atm_fee": "ATM费",
    "received": "已接收",
    "incremental": "追加",
    "bill_address_save_success": "账单地址保存成功",
    "no_more_trans_record": "没有更多交易记录",
    "withdraw_amount_larger_than_available": "超过最大可用余额",
    "withdraw_lower_than_min": "低于最低提款额",
    "card_is_deleted": "卡片已删除",
    "something_error": "出错了",
    "home": "首页",
    "select_country": "选择国家",
    "billing_list": "账单列表",
    "coupon_code": "优惠码",
    "password_rule1": "8到32个字符",
    "password_rule2": "至少一个大写英文字母",
    "password_rule3": "至少一个小写英文字母",
    "password_rule4": "至少一个数字",
    "set_pw": "设置密码",
    "reissue_fee": "补发费用",
    "card_trans_detail_status_refund": "退款处理中",
    "card_trans_status_reversal": "撤销",
    "card_trans_status_fully_refund": "已处理,全部退款",
    "card_trans_status_partial_refund": "已处理,部分退款",
    "card_trans_status_void": "无效",
    "fx_fee_desc": "外汇费（FX费）包括1.2%的非默认货币交易手续费。（如适用）",
    "atm_fee_desc": "每笔ATM取款会收取2%的额外费用。",
    "remit_fee_desc": "外汇费（FX费）包括1%的交易费和1.2%的非默认货币交易费。",
    "risk_safety_tips": "安全提示",
    "risk_safety": "为了安全起见，请在执行任何相关操作前，先在APP中完成人脸识别验证。",
    "go_to_app_verify": "前往APP进行验证",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "立即去 RedotPay",
    "close": "关闭",
    "charging_rules": "充值规则",
    "reissue_card": "补卡换卡",
    "card_cancellation": "删除卡片",
    "update_cvv": "更新CVV",
    "update_cvv_desc": "相同的卡号，新CVV、以及新的有效期",
    "delete_card": "删除卡片",
    "delete_card_desc": "删除后卡片将无法使用，此操作不可撤销。",
    "deleting_fee": "卡片删除费",
    "delete": "删除",
    "currency_tips": "提示",
    "at_least_one_currency": "请至少保留一种可支付的货币。",
    "all_select_currency": "您已支持全部的货币来完成交易。",
    "payment_currency_settings": "支付货币设置",
    "customize_payment_currency": "自定义付款货币",
    "disable_non_local_tip": "禁用非本地货币的交易可有效降低银行卡盗刷风险",
    "small_auth_transaction_fee_stas": "小额交易费详情",
    "small_transactions_this_month": "当月小额交易次数",
    "small_autn_trans_remain": "当月小额交易豁免次数",
    "rules": "规则",
    "failed_rules": "交易失败将增加不良交易记录的数量，超出豁免数后将收取额外费用。请规范交易。",
    "rule_item": "项目",
    "free_count": "免费次数",
    "fees": "费用",
    "declined_trans_remain": "当月拒绝交易豁免次数",
    "declined_transaction_fee_stats": "拒绝交易费详情",
    "declined_rules": "交易失败将增加不良交易记录的数量，超出豁免数后将收取额外费用。请规范交易。",
    "declined_transactions_this_month": "当月拒绝交易次数",
    "first_time_free": "首次免费",
    "FxFee": "外汇费",
    "AtmFee": "ATM费",
    "RemitFee": "汇款费",
    "MccFee": "特别商户手续费",
    "SmallAuthFee": "小额交易费",
    "mcc_fee_desc": "部分商户会收取交易金额 1.5% 的额外费用。如果费用低于 0.5 美元，将收取最低 0.5 美元的费用。",
    "please_deposit": "余额不足，请充值",
    "special_mcc_fee": "特别商户交易费",
    "bank_verifying": "这笔退款银行正在审核中……",
    "estimate_time": "预计到账2-30天",
    "delete_out": "注销",
    "card_is_loss": "卡片已挂失",
    "incremental_desc": "如果授权金额不足，会产生追加收费，相关金额将在结算时添加。",
    "card_trans_status_fully_refund1": "已清算",
    "card_trans_status_fully_refund2": "全额退款",
    "card_trans_status_partial_refund1": "已清算",
    "card_trans_status_partial_refund2": "部分退款",
    "loss_card": "挂失",
    "review_takes_time": "审核时间约为 2 分钟至 24 小时。",
    "custom_date_null": "请选择自定义日期",
    "custom_date_error": "请设置正确的查询时间",
    "small_trade_fee": "小额交易手续费",
    "user_risk_exception": "用户状态异常",
    "request_exception": "请求结果错误",
    "mobile_is_not_empty": "请输入正确的手机号码",
    "code_is_not_empty": "请输入正确的验证码",
    "browser_paste_error": "浏览器限制，请手动输入"
  }
};